import e from "../../../../@babel/runtime/helpers/esm/extends.js";
import o from "../isHostComponent/isHostComponent.js";
function i(n, t, r) {
  return n === void 0 || o(n) ? t : e({}, t, {
    ownerState: e({}, t.ownerState, r)
  });
}
export {
  i as default
};
